import { Download } from "lucide-react";
import { qrUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

export const QRCode = ({ data, label, filename = "satish-qr", size = 180 }) => {
  const handleDownload = () => {
    trackEvent("qr_download", { label: label || filename, filename });
    const a = document.createElement("a");
    a.href = qrUrl(data, filename, true);
    a.download = `${filename}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="bg-white p-5 rounded-2xl border-2 border-navy/15 shadow-lg text-center inline-flex flex-col items-center" data-testid={`qr-card-${filename}`}>
      <img
        src={qrUrl(data, filename)}
        alt={`QR code for ${label || data}`}
        width={size}
        height={size}
        className="rounded-lg"
        style={{ width: size, height: size }}
      />
      {label && <div className="mt-3 font-semibold text-navy text-sm">{label}</div>}
      <div className="text-xs text-slate-400 mt-1 break-all max-w-[200px]">{data}</div>
      <Button
        onClick={handleDownload}
        variant="outline"
        size="sm"
        className="mt-3 border-navy/30 text-navy hover:bg-sky"
        data-testid={`qr-download-${filename}`}
      >
        <Download className="w-4 h-4 mr-1.5" /> Download
      </Button>
    </div>
  );
};
